<template>
	<div
		:class="context.classes.element"
		:data-type="context.type"
	>
		<input
			:type="type"
			v-model="context.model"
			:value="context.value"
			v-bind="context.attributes"
			@blur="context.blurHandler"
		>
		<component
			:is="`label`"
			v-if="usesDecorator"
			:for="context.attributes.id"
			class="bg-gray-500 w-8 h-5 p-1 rounded-full relative"
		>
			<div
				class="absolute top-1 w-3 h-3 bg-white rounded-full"
			></div>
		</component>
	</div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";

export default {
    name: "SwitchBox",
    mixins: [FormulateInputMixin],
    computed: {
    	type() {
    		return this.context.type === "switchbox" ? "checkbox" : "radio";
        },
        usesDecorator () {
            return this.$formulate.options.useInputDecorators
        }
    }
}
</script>

<style scoped>
input ~ label {
	@apply bg-gray-500;
}
input ~ label > div {
	@apply left-1;
}

input:checked ~ label {
	@apply bg-green-500;
}
input:checked ~ label > div {
	@apply left-4;
}
</style>

<style>
.formulate-input[data-classification=box] .formulate-input-element {
	overflow: inherit !important;
}
</style>